import { render, staticRenderFns } from "./editMeal.vue?vue&type=template&id=25b3853e&scoped=true"
import script from "./editMeal.vue?vue&type=script&lang=js"
export * from "./editMeal.vue?vue&type=script&lang=js"
import style0 from "./editMeal.vue?vue&type=style&index=0&id=25b3853e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b3853e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25b3853e')) {
      api.createRecord('25b3853e', component.options)
    } else {
      api.reload('25b3853e', component.options)
    }
    module.hot.accept("./editMeal.vue?vue&type=template&id=25b3853e&scoped=true", function () {
      api.rerender('25b3853e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/mealList/editMeal.vue"
export default component.exports